var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upsert-contact-property-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "contactModuleRules.upsertContactPropertyConfig.propertySelect"
              )
            )
          ),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: {
              placeholder: _vm.$t(
                "contactModuleRules.upsertContactPropertyConfig.selectProperty"
              ),
              "filter-option": _vm.filterOption,
            },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.propertyId,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "propertyId", $$v)
              },
              expression: "localConfig.propertyId",
            },
          },
          _vm._l(_vm.contactProperties, function (property) {
            return _c(
              "a-select-option",
              { key: property._id, attrs: { value: property._id } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(property.label) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "contactModuleRules.upsertContactPropertyConfig.propertyHint"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.$t("contactModuleRules.upsertContactPropertyConfig.value")
            )
          ),
        ]),
        _vm._v(" "),
        _c("a-input", {
          attrs: {
            placeholder: _vm.$t(
              "contactModuleRules.upsertContactPropertyConfig.valuePlaceholder"
            ),
          },
          on: { change: _vm.emitChange },
          model: {
            value: _vm.localConfig.value,
            callback: function ($$v) {
              _vm.$set(_vm.localConfig, "value", $$v)
            },
            expression: "localConfig.value",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            _vm._s(
              _vm.$t("contactModuleRules.upsertContactPropertyConfig.valueHint")
            )
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }